<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Thanks for submitting your report</h1>
			<p>
				We will be in touch!
			</p>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: "Yahoo",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>